// Session-lived media cache: a preview/poster blob URL per source message id.
// Shared by the feed (group-history thumbnails) and the compose editor (draft
// thumbnails) so a photo/video is downloaded from Telegram only ONCE per
// session, not on every feed open or compose re-mount. Bounded by how many
// media messages you've actually viewed. Never revoked mid-session — the URLs
// must stay valid for any cached <img>/<video> still in the DOM.
//
// Keyed by "<chat>:<mtproto message id>". The chat prefix is required: MTProto
// message ids are only unique within a namespace — DMs share the account's
// counter, but every supergroup has its OWN counter starting near 1, so two
// groups routinely hold the same bare id and a bare-id key serves one chat's
// photo in another.
//
// A persistent IndexedDB layer (media-store.ts) backs this map across
// reloads; this map remains the only source of live blob URLs.
export const mediaCache = new Map<string, string>();
